import { useTranslation } from 'next-i18next';
import { confirmDialog } from '@/ui_v3';

/**
 * 클래스 카드/행을 눌렀을 때의 연결·해제 동작.
 *
 * 그리드형(`ClassroomLinkCard`)과 리스트형(`ClassroomLinkRow`)이 같은 판단을 해야 해서
 * 여기로 뺐다. 특히 **해제에는 확인을 받는다**는 규칙이 한쪽에만 남으면, 어느 화면에서
 * 눌렀느냐에 따라 학생 기록이 말없이 끊긴다.
 */
export function useClassroomLinkToggle({
  classGroupId,
  isPending,
  isLinked,
  linkedClassLinkId,
  onLink,
  onUnlink
}: {
  classGroupId: string;
  isPending: boolean;
  isLinked: boolean;
  linkedClassLinkId?: string;
  onLink: (classroomId: string) => void;
  onUnlink: (classroomId: string, classLinkId: string) => void;
}) {
  const {
    t
  } = useTranslation(['common']);
  const toggle = async () => {
    if (isPending) return;
    if (isLinked && linkedClassLinkId) {
      const confirmed = await confirmDialog.openAsync({
        size: 'xs',
        header: {
          title: t('common:classroomLink.unlinkConfirmTitle')
        },
        body: t('common:classroomLink.unlinkConfirmBody'),
        cancelText: t('common:classroomLink.unlinkCancelButton'),
        confirmText: t('common:classroomLink.unlinkConfirmButton'),
        confirmIntent: 'destructive',
        shouldCloseOnDimClick: false
      });
      if (!confirmed) return;
      onUnlink(classGroupId, linkedClassLinkId);
      return;
    }
    onLink(classGroupId);
  };
  return {
    toggle
  };
}